// removed by extract-text-webpack-plugin
module.exports = {"white":"#ffffff","desktop":"1366px","ipad":"1024px","wrapper":"_1DNxB8A5bPz7ysjE6w17zh","container":"_24X2Y_xFSZ642WTQJHTT9Q","link":"TBNBdNeKRPLGlg1t978GK","actionLink":"_2PUf_aMaPIB4OwTmNz0Ozv","button":"_2v8HAeGwi65NL6Zw6KrsHo","map":"_2XF8PMeYol0IIH8jjf8g4U"};


//////////////////
// WEBPACK FOOTER
// ./src/uis/components/Banner/HeroBanner/MapSection/MapSection.css
// module id = 1405
// module chunks = 0